import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const AboutUs = () => <PublicStaticPage pageKey="about" />;

export default AboutUs;
